import React, { FC } from 'react';
import { DoubleCtaCardFragment } from '../types/graphqlTypes';
import { CTACard } from './CtaCard';
import { Grid } from './Grid';

// JSX
interface DoubleCtaCardProps extends DoubleCtaCardFragment {
  shadow?: boolean;
  headingComponent?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export const DoubleCTACard: FC<Omit<DoubleCtaCardProps, '__typename'>> = ({ ctas, shadow, headingComponent }) => {
  if (ctas.length < 1) {
    return null;
  }

  return (
    <Grid desktopColumns="2">
      {ctas.map((card, index) => (
        <CTACard {...card} key={`cta-card-${index}`} shadow={shadow} headingComponent={headingComponent} />
      ))}
    </Grid>
  );
};
